import type { ConfigurationKeySnapshot } from '@/domain';
import type { StationId } from '@/domain/types';
import type { ConfigurationRepository } from '@/persistence/ports';
import type { Evse3Database } from '../db';

export class ConfigurationRepositoryDexie implements ConfigurationRepository {
  constructor(private readonly db: Evse3Database) {}

  async byStation(stationId: StationId): Promise<readonly ConfigurationKeySnapshot[]> {
    const rows = await this.db.configurations.where('stationId').equals(stationId).toArray();
    return rows.map(({ stationId: _s, ...rest }) => rest);
  }

  async get(stationId: StationId, key: string): Promise<ConfigurationKeySnapshot | null> {
    const row = await this.db.configurations.get([stationId, key]);
    if (!row) return null;
    const { stationId: _s, ...rest } = row;
    return rest;
  }

  async upsert(stationId: StationId, snap: ConfigurationKeySnapshot): Promise<void> {
    await this.db.configurations.put({ stationId, ...snap });
  }

  async delete(stationId: StationId, key: string): Promise<void> {
    await this.db.configurations.delete([stationId, key]);
  }
}
